import { Actions } from './Actions'
import { Content } from './Content'
import { Header } from './Header'

export const Overlay = { Content, Header, Actions }
